<div class="row new-project-body" [class.editForm]="true">
    <div class="container-fluid" [formGroup]="form" *ngIf="form">
        <div class="row mt-4">
            <div class="form-group col-lg">
                <label>{{'order.budget.project.name' | translate}} *</label>
                <apc-form-input [class]="'form-control'" formControlName="name" [type]="'text'">
                </apc-form-input>
            </div>
        </div>
        <div class="row mt-4">
            <div class="form-group col-lg">
                <label>{{'order.budget.project.description' | translate}}</label>
                <apc-form-input [class]="'form-control'" formControlName="description" [type]="'text'">
                </apc-form-input>
            </div>
        </div>
        <div class="row mt-4">
            <div class="form-group col-lg">
                <label>{{'order.budget.project.jiraTemplate' | translate}} * <apc-help-icon
                        [text]="'buttons.help.newProject'"></apc-help-icon></label>
                <apc-form-select formControlName="template" [items]="jiraTemplates" [isObject]="true"
                    [optionName]="'templateName'" [optionValue]="'templateName'"
                    [optionDescription]="['templateDescription']" (isOpen)="fetchTemplates()"
                    [loading]="jiraTemplatesLoading" [hideDescTitle]="true">
                </apc-form-select>
            </div>
        </div>
        <div class="row mt-4" style="position: relative;">
            <div class="form-group col-lg-11 user-chips">
                <label>{{'order.pm' | translate}} {{this.budget?.type?.projectManagerRequired ? '*' : ''}}</label>
                <img *ngIf="loadingUsers" src="assets/ico/loading.svg" class="loading-users" alt="loading users" />
                <tag-input formControlName="projectManagers" [modelAsStrings]="false" (onAdd)="form.markAsDirty()"
                    (onRemove)="form.markAsDirty()" [disable]="false" [placeholder]="'Find New User'"
                    [secondaryPlaceholder]="'Find User'" [displayBy]="'username'" [identifyBy]="'username'"
                    [onlyFromAutocomplete]="true" [allowDupes]="false" (onTextChange)="textChange($event)">
                    <tag-input-dropdown [showDropdownIfEmpty]="false" [zIndex]="9999" 
                        [autocompleteObservable]="getJiraUsers" [displayBy]="'username'" [identifyBy]="'username'">
                    </tag-input-dropdown>
                </tag-input>
                <div *ngIf="noUsersResult">
                    <div class="no-results-pm">No Results</div>
                </div>
            </div>
            <div class="form-group col-lg-1" style="position: absolute; bottom: 0px; right: 16px;"
                (click)="addMyself()">
                <div ngbTooltip="{{'buttons.addMyself' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" class="extra-button light-blue modal-icon icon fill-white"
                    aria-label="add myself" [inlineSVG]="'assets/ico/user-regular.svg'">
                </div>
            </div>
        </div>

        <div class="row mt-4 mb-5">
            <div class="form-group col-lg">
                <label>{{'order.budget.project.projectKey' | translate}}</label>
                <apc-form-input [class]="'form-control'" formControlName="jiraKey" [type]="'text'">
                </apc-form-input>
            </div>
        </div>
        <div class="modal-footer p-0">
            <div class="container-fluid m-0 p-0">
                <span class="btn modal-btn save" (click)="createProject($event)">
                    {{'buttons.newProject' | translate}}</span>
                <span class="btn modal-btn save back" (click)="cancel()">{{'buttons.back' | translate }}</span>
            </div>
        </div>
    </div>
</div>